import React, {useEffect, useRef, useState} from 'react';
import { BuildPath } from '../../../helpers/Paths';

interface Step2Props {
    setValid:(valid: boolean)=> void
    setFile:(file: HTMLInputElement) => void
}

const Step2 = ({setValid, setFile}: Step2Props) => {
    const [fileLoaded, setFileLoaded] = useState<boolean>(false);

    const file = useRef<HTMLInputElement>(null);


    useEffect(() => {
        if(!fileLoaded){
            setValid(false)
        }
    }, [fileLoaded]);

    function handleFileChange(): void{
        if (file.current.files.length && isFileValid(file.current.files[0].name.split('.')[1])){
           setValid(true)
           setFile(file.current);
           setFileLoaded(true)
        } 
        else{
           setValid(false)
        }
             
    }

    function isFileValid(fileExtention:string) : boolean {
        const allowedFileExtentions = ['csv','xls','xlsx'];
        return allowedFileExtentions.indexOf(fileExtention) >= 0;
    }

    function unsetFile(){
        setFileLoaded(false);
        setValid(false);
        file.current.value = "";
    }

    return (
        <React.Fragment>

            <p>Upload a CSV or Excel file with your users’ details to update existing users, add new users and remove users.</p>
            <div className="file-upload-wrapper">
                <input ref={file} onChange={handleFileChange} className="user-file-upload" type="file" id="myFile" name="Choose File" accept=".csv" aria-label="Choose File" />
                {fileLoaded && <button onClick={unsetFile}><img src={`${BuildPath()}/images/buttons/CloseModal.svg`} alt="remove file"/></button> }
            </div>
            
        </React.Fragment>
    );
};

export default Step2;